import ApiUrl from "../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));

const GetProductCreate = (setAllCategoryList,setCategoryList) => {
    fetch(ApiUrl.API_URL_Collection)
    .then(res=>res.json())
    .then(data =>{
        setAllCategoryList(data);
        let collectionListSend = [];
        for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if(element.parentid === 0){
            if(User.role === 'individual' || User.role === 'business'){
                if(element.type === 1){
                collectionListSend.push({
                    name: element.title,
                    value: String(element.id)
                })
                }
            }
            else{
                if(element.type === 3){
                collectionListSend.push({
                    name: element.title,
                    value: String(element.id)
                })
                }
            }
            }
        }
        setCategoryList(collectionListSend);
    });
}

const ProductCreateChangeState = (v,setCategory,setSubcategory,allcategoryList,setCategoryList,setState) =>{
    let collectionListSend = [];
    setCategory({name:'Select', value:'0'});
    setSubcategory({name:'Select', value:'0'});
    if(parseInt(v.value) === 1){
      for (let index = 0; index < allcategoryList.length; index++) {
        const element = allcategoryList[index];
        if(element.parentid === 0){
          if(element.type === 1){
            collectionListSend.push({
              name: element.title,
              value: String(element.id)
            })
          }
        }
      }
    }
    else{
      for (let index = 0; index < allcategoryList.length; index++) {
        const element = allcategoryList[index];
        if(element.parentid === 0){
          if(element.type === 2){
            collectionListSend.push({
              name: element.title,
              value: String(element.id)
            })
          }
        }
      }
    }
    setCategoryList(collectionListSend);
    setState(v);
  }
  const ProductCreateChangeCategory = (v,allcategoryList,setSubcategoryList,setCategory) =>{
    let collectionListSend = [];
    for (let index = 0; index < allcategoryList.length; index++) {
      const element = allcategoryList[index];
      if(String(element.parentid) === v.value){
        collectionListSend.push({
          name: element.title,
          value: String(element.id)
        })
      }
    }
    setSubcategoryList(collectionListSend);
    setCategory(v);
  }

export default {GetProductCreate,ProductCreateChangeCategory,ProductCreateChangeState}